import {
  Box,
  Skeleton,
  Grid,
  Stack,
  useTheme,
  useMediaQuery,
} from '@/theme/index';

export const ReportLoading = ({ menuItems }: { menuItems?: number }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const photosPlaceholderItems = isMobile ? [1] : [1, 2, 3, 4];

  menuItems = menuItems || 5;
  const rows = Array.from(Array(menuItems).keys());

  return (
    <Grid container columns={12} spacing={7}>
      <Grid item lg={4} sx={{ display: { xs: 'none', lg: 'block' } }}>
        <Box minWidth={262} px={2.5} py={3.75} bgcolor="background.paper">
          {rows.map((row) => (
            <Skeleton
              width="100%"
              height={19}
              variant="rectangular"
              key={row}
              sx={{ mb: 2 }}
            />
          ))}
        </Box>
      </Grid>
      <Grid item xs={12} md={12} lg={8}>
        <Grid container bgcolor="background.paper" px={2.5} py={3.75}>
          <Grid mb={2.5} xs={12} item>
            <Stack direction="row" justifyContent="space-between" spacing={2.5}>
              {[1, 2, 3, 4].map((item) => (
                <Skeleton
                  variant="rounded"
                  width="25%"
                  height={40}
                  key={item}
                />
              ))}
            </Stack>
          </Grid>
          <Grid container mb={2.5} justifyContent="space-between">
            <Grid item xs={12} sm={7}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={44}
                sx={{ mb: 1.5 }}
                role="status"
              />
              {[1, 2, 3, 4].map((item) => (
                <Skeleton
                  variant="rectangular"
                  width={252}
                  height={24}
                  sx={{ mb: 1.5 }}
                  key={item}
                />
              ))}
            </Grid>
            <Grid item xs={12} sm={4}>
              <Skeleton variant="rounded" width="100%" height={142} />
            </Grid>
          </Grid>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <Grid key={item} item xs={12}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={2}
                sx={{ mb: 2.5 }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={19}
                sx={{ mb: 2.5 }}
              />
            </Grid>
          ))}
          <Grid mb={2.5} xs={12} item>
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={2.5}
              px={5}
            >
              {photosPlaceholderItems.map((item) => (
                <Skeleton
                  variant="rectangular"
                  width={isMobile ? '100%' : '25%'}
                  height={152}
                  key={item}
                />
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
